//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    value: '',
  }),
  mounted() {
    this.value = this.name;
  },
};
